import React, { ContextType, createContext } from 'react';
import { common } from '@kurtosys/ksys-app-template';

import { IComponentBaseProps } from '../models/IComponentBaseProps.js';
import { IComponentConfiguration } from '../models/IComponentConfiguration.js';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ConfigurationContext = createContext<IComponentConfiguration>({});

export interface IWithConfigurationProps {
	configuration?: IComponentConfiguration;
}

export interface IWithConfigurationState {
	mergedConfiguration?: IComponentConfiguration;
	overrideConfiguration?: IComponentConfiguration;
}

export const withConfiguration = <P extends IComponentBaseProps>(
	// eslint-disable-next-line @typescript-eslint/naming-convention
	Component: React.ComponentType<P>,
) =>
	class WithLoading extends React.Component<P & IWithConfigurationProps, IWithConfigurationState> {
		constructor(props: P & IWithConfigurationProps) {
			super(props);
			this.state = {};
		}
		static contextType = ConfigurationContext;
		context: ContextType<typeof ConfigurationContext> | null = null;
		get configuration() {
			return this.state.mergedConfiguration;
		}
		orchestrateConfiguration = (props: P) => {
			const contextConfiguration = this.context;
			const { configuration: propsConfiguration } = props;
			if (propsConfiguration) {
				return common.commonUtils.deepMergeObjects(contextConfiguration, propsConfiguration);
			}
			return contextConfiguration;
		};
		getStateFromProps = (props: P): IWithConfigurationState => {
			return {
				mergedConfiguration: this.orchestrateConfiguration(props),
				overrideConfiguration: props.configuration,
			};
		};
		// The parameters must be of type "any" otherwise it will break ¯\_(ツ)_/¯
		static getDerivedStateFromProps(nextProps: any, previousState: any) {
			if (nextProps.configuration !== previousState.overrideConfiguration) {
				return { mergedConfiguration: null };
			}
			return null;
		}
		componentDidUpdate() {
			if (!this.state.mergedConfiguration) {
				this.setState(this.getStateFromProps(this.props));
			}
		}
		componentDidMount() {
			if (!this.state.mergedConfiguration) {
				this.setState(this.getStateFromProps(this.props));
			}
		}
		render() {
			const { ...props } = this.props;
			const configuration = this.context;
			return <Component configuration={configuration} {...(props as P)} />;
		}
	};
